export default {
  // ljy语言配置
  Reset_default_style: "恢复默认风格",
  Modify_style: "修改风格",
  Add_new_style: "新增风格",
  You_must_save_it_again_for_the_changes_to_take_effect:
    "对风格进行修改后，须重新保存，才可生效；",
  Click_to_add_a_new_style_After_entering_the_style_name_and_pressing_Enter_or_clicking_outside_the_input_box_the_style_can_be_saved:
    "点击可新增风格，输入风格名称后回车或点击输入框外区域即可保存；",
  Click_to_use_the_initial_default_style: "点击可使用初始默认风格；",
  Drag_and_drop_fields_to_sort: "可拖拽字段进行排序；",
  Each_SKU_storage_fee_calculation_starts_from_the_batch_entry_date:
    "每个SKU入库批次开始计算仓租天数",
  Dispatch_return_items: "下发退件",
  Only_save_the_hour_minute_and_second_of_the_confirmation_time:
    "仅保存确认时间的时分秒",
  When_conducting_a_quick_search: "快捷查询时",
  the_default_end_date_is_set_to_today_date: "默认结束日期为今日日期",
  Query_the_start_date_based_on_the_saved_time_period_in_real_time:
    "根据保存的时间段实时查询开始日期",
  Today_delivery: "当日达",
  Nextday_delivery: "次日达",
  Today_delivery_Platform: "平台今日达",
  Today_delivery_Shopee: "Shopee今日达",
  Nextday_delivery_Shopee: "Shopee次日达",
  Today_delivery_Lazada: "Lazada今日达",
  Nextday_delivery_Lazada: "Lazada次日达",
  Today_delivery_Tiktok: "Tiktok今日达",
  Nextday_delivery_Tiktok: "Tiktok次日达",
  Today_delivery_Temu: "Temu今日达",
  Nextday_delivery_Temu: "Temu次日达",
  You_cannot_choose_both_today_and_next_day_delivery:
    "不能同时选择今日达与次日达",
  Failed_to_load_custom_fields: "加载自定义查询字段失败",
  Has_Invoice: "有无发票",
  The_file_naming_format_is_incorrect_the_last_item_must_be_the_invoice_serial_number_id_a_pure_number:
    "文件命名格式不正确，最后一项必须是发票流水号id（纯数字）",
  manageAddTransferOutTask: "创建移仓迁出任务",
  manageEditTransferOutTask: "编辑移仓迁出任务",
  No_available_goods: "暂无可用商品",
  One_click_transfer_out_goods: "一键迁出商品",
  Select_Inventory_Product: "选择库存商品",
  Pickup_at_location: "上门",
  Delivery_service: "快递",
  Truk_delivery: "卡派",
  transfer_out_type: "迁出类型",
  shipped_method: "发运方式",
  Failed_to_retrieve_current_logged_in_customer_information:
    "获取当前登录客户信息失败",
  ATrigger_an_alert_when_the_current_time_minus_the_task_start_time_exceeds_the_warning_threshold_notify_the_corresponding_account_of_the_role_in_their_to_do_list:
    "当前时间-任务开始时间＞预警值时触发预警；通知到角色对应账号的待办中",
  Trigger_an_alert_when_the_inventory_quantity_at_a_storage_location_is_below_the_warning_threshold_and_there_is_stock_available_in_backup_or_temporary_locations:
    "库位库存数量＜预警值，且在备货或临时库位有货的情况下触发预警；",
  The_notification_will_be_sent_to_the_corresponding_role_s_account_as_a_pending_task:
    "通知到角色对应账号的待办中",
  Return_Order_Daily_Logistics_Page: "每日物流退件收货报表",
  Return_Order_Daily_Logistics_Customer_Page: "每日客户物流退件收货报表",
  Return_Order_Daily_Logistics_Product_Page: "每日客户退货商品收货报表",
  Return_Order_Monthly_Logistics_Product_Page: "每月客户退货商品收货报表",
  Please_select_the_customer_company: "请选择客户公司",
  isolated_storage_location_up: "隔离库位上架",
  notificationAccount: "通知账号配置",
  Add_notification_account: "添加通知账号",
  Staff_account: "通知人",
  Staff_status: "启用状态",
  Please_select_currency_type: "请选择币种",
  Please_Select_WMS_status: "请选择WMS状态",
  When_using_corporate_online_banking_for_payment: "使用企业网银支付时",
  a_handling_fee_of_10_RMB_per_transaction_will_be_charged_if_the_single_recharge_amount_is_less_than_5000_RMB:
    "单笔充值金额小于5000 RMB时，收取10 RMB/笔手续费",
  deducted_from_the_recharge_amount: "在充值金额中扣除",
  otherwise_no_fee_will_be_charged: "其余情况免费",
  Operational_video: "操作视频",
  Please_upload_mp4_format_video_file_and_not_more_than_300_MB:
    "请上传.mp4格式的视频，文件大小不超过300MB",
  Upload: "上传",
  Reschedule_delivery: "重新预约发货", // 1
  Only_Shopee_today_delivery_orders_can_be_rescheduled_for_shipment:
    "仅支持Shopee今日达的订单重新预约发货",
  Order_does_not_meet_the_conditions_for_rescheduling: "订单不满足重新预约条件",
  System_platform_delivery_tag: "系统平台发货标签",
  Global_summary_tag: "全局汇总标签",
  Cross_platform_unified_management_of_shipping_priority:
    "跨平台统一管理发货优先级",
  Platform_order_delivery_tag: "平台订单发货标签",
  Refine_native_tag: "细化原生标签",
  Used_to_preserve_platform_the_specific_timeliness_and_calling:
    "用于保留各平台特定时效和称呼",
  Meet_platform_differentiated_timeliness_requirements: "满足平台差异化时效",
  Daily_cutoff_time: "每日截单时间",
  Local_time: "当地时间",
  System_delivery_tag_configuration: "系统发货标签配置",
  Create_configuration: "创建配置",
  Edit_configuration: "编辑配置",
  Batch_edit_cutOff_time: "批量编辑截单时间",
  Delivery_country: "配送国家",
  Platform_delivery_tag: "平台发货标签",
  channel_id: "渠道ID",
  channel_name: "渠道名称",
  "Shopee_Instant_delivery_(10_min_packing)": "Shopee即时达(10分钟打包)",
  "Shopee_Instant_delivery_(30_min_packing)": "Shopee即时达(30分钟打包)",
  "Shopee_Instant_delivery_(60_min_packing)": "Shopee即时达(60分钟打包)",
  "Shopee_Instant_delivery_(90_min_packing)": "Shopee即时达(90分钟打包)",
  "Shopee_Instant_delivery_(2_hours_packing)": "Shopee即时达(2小时打包)",
  Shopee_Instant_delivery: "Shopee即时达",
  Lazada_Priority_delivery: "Lazada优先发货",
  Tiktok_Instant_delivery: "Tiktok即时达",
  "Tiktok_Same-day_delivery_8_hours": "Tiktok当日达8小时",
  "Tiktok_Same-day_delivery": "Tiktok当日达",
  "Tiktok_Next-day_delivery": "Tiktok次日达",
  Instant_delivery_10_min: "即时达(10分钟)",
  Instant_delivery_30_min: "即时达(30分钟)",
  Instant_delivery_60_min: "即时达(60分钟)",
  Instant_delivery_90_min: "即时达(90分钟)",
  Instant_delivery_2_hours: "即时达(2小时)",
  Instant_delivery: "即时达",
  Please_Select: "请选择",
  "Next-day_delivery": "次日达",
  "Same-day_delivery_8_hours": "当日达8小时",
  Priority_delivery: "优先发货",
  "Same-day_delivery": "当日达",
  Get_platform_logistics_channels: "获取平台物流渠道",
  Batch_edit_platform_delivery_tag: "批量编辑平台发货标签",
  'The_cutoff_time_is_based_on_Beijing_time.Orders_created_before_the_cutoff_time_will_be_shipped_the_same_day_and_labeled_as"Same-Day_Delivery."':
    '截单时间以北京时间为准。截单时间前创建的订单，当日发货并打"当日达"标签',
  'Orders_created_after_the_cutoff_time(including_exactly_at_the_cutoff_time)will_be_shipped_the_next_day_and_labeled_as"Next-Day_Delivery."':
    '截单时间后（含准点）创建的订单，次日发货并打"次日达"标签。',
  "If_a_warehouse_public_holiday_occurs,_shipping_will_be_postponed_to_the_next_business_day.":
    "若遇仓库法定节假日，发货时间顺延至下一工作日。",
  "The_system_automatically_retrieves_and_retains_the_original_order_shipping_labels_from_each_platform.":
    "系统自动拉取并保留各平台的原始订单发货标签。",
  'The_system_generates_shipping_labels_based_on_platform_order_summaries_and_automatically_classifies_orders_as_"same-day_delivery"or"next-day_delivery"by_integrating_the_platform-specific_and_country-specific"daily_cutoff_times"_configured_in_the_system.':
    "系统基于平台订单发货标签汇总生成，结合系统对各平台、各国家配置的“每日截单时间”，自动将订单划分为“当日达”或“次日达”。",
  'The_classification_criteria_are_as_follows:_If_the_order_creation_time_is_earlier_than_the_daily_cut-off_time,it_is_classified_as"same-day_delivery";_if_the_order_creation_time_is_later_than_the_daily_cut-off_time,it_is_classified_as"next-day_delivery".':
    "划分标准为：订单创建时间早于每日截单时间的，判定为“当日达”；订单创建时间晚于每日截单时间的，判定为“次日达”。",
};
